import React from 'react'

export default function AgentComment({visibleMessage,setVisibleMessage}) {
    return (
        <div className="tool-tip-cont">
            <div className="tool-tip">Հաղորդագրություններ</div>
            <div className="icon-button"
                onClick={() => setVisibleMessage(!visibleMessage)}>
                <div className="add-file">
                    <i className="fas fa-envelope" />
                    {/* {!visibleMessage && data?.new_sms_count !== 0 ? (
                        <div className="tasks-around">{data?.new_sms_count}</div>
                    ) : null} */}
                </div>
            </div>
        </div>
    )
}
